import type { ProductCondition, ProductStatus } from '../types';

export const conditionLabels: Record<ProductCondition, string> = {
  like_new: 'משומש כמו חדש',
  needs_cleaning: 'משומש נדרש ניקוי',
  new: 'חדש'
};

export const statusLabels: Record<ProductStatus, string> = {
  active: 'פעיל',
  reserved: 'שמור',
  sold: 'נמכר',
  hidden: 'מוסתר'
};

export function money(cents: number): string {
  return `${new Intl.NumberFormat('he-IL').format(cents / 100)} ₪`;
}
